export default __webpack_public_path__ + "static/media/warning-circle.c1ce1289.svg";